var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-sendgrid"},[_c('edit',{attrs:{"fs":_vm.sendgridFields,"api":"settings","id":"sendgrid","title":"SendGrid Setting"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }